import { render, staticRenderFns } from "./payslip.view.vue?vue&type=template&id=57165cf1&scoped=true&"
import script from "./payslip.view.vue?vue&type=script&lang=ts&"
export * from "./payslip.view.vue?vue&type=script&lang=ts&"
import style0 from "./payslip.view.vue?vue&type=style&index=0&id=57165cf1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57165cf1",
  null
  
)

export default component.exports